import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'fancyFullDate'
})
export class FancyFullDatePipe implements PipeTransform {
  transform(value: any) {
    if (value != null && value != 0) {
      if (value.seconds) {
        let newDate = new Date(value.seconds * 1000);
        return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + this.withZero(newDate.getHours()) + ":" + this.withZero(newDate.getMinutes());
      } if (value._seconds) {
        let newDate = new Date(value._seconds * 1000);
        return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + this.withZero(newDate.getHours()) + ":" + this.withZero(newDate.getMinutes());
      } else {
        if (typeof value === 'string' || value instanceof String) {
          value = new Date(value + "");
        } else {
          if (Number.isInteger(value)) {
            value = new Date(value);
          }

        }
        return value.getDate() + "/" + (value.getMonth() + 1) + "/" + value.getFullYear() + " & " + (value.getHours()%12 || 12).toString().padStart(2, '0') + ":" + value.getMinutes().toString().padStart(2, '0') +" "+(value.getHours() >= 12 ? 'PM' : 'AM');
      }
    } else {
      return "-";
    }
  }

  withZero(time) {
    return time > 9 ? time : "0" + time;
  }
}
